module.exports = {
  logon: {
    signIn: "Sign In",
    passwordLogin: "Password Login",
    login:"Log In Now",
    iptAccount:"User name/Mobile phone number/Email",
    selectCustomer:"Please select customer",
    iptPassword: "Please enter the password",
    iptPasswordLen: "Password length is at least 6 digits",
    iptCheckcode:"Please enter the verification code",
    iptTrueCheckcode:"Please enter correct verify code",
    iptCheckcodeLen: "Verification code length 4 bits",
    forgetPassword: "Forgot password",
    register:"Register",
    home:"Home",
    customService:"Custom Service",
    about:"About",
    agree: "I have read and agree",
    privacyPolicy: "privacy policy",
    agreeMsg: "Please agree to the privacy policy",
    selectEnterprise: "Login Enterprise Selection",
    copyRight: "CIIC Payroll & Tax Tech Service Co., Ltd. All rights reserved.",
    passwordTipTitle: "Password modification prompt",
    passwordTipContent: "Hello, you have not changed your password for a long time. For the security of your account, we suggest that you change your password!",
    updatePwdTipContent: "Hello, for the security of your account, it is recommended that you change the initial password!"
  },
  navbar: {
    userPhoto: "profile picture",
    switchLang:"Switch language"
  },
  areYouSureToSubmit: 'Are you sure to submit?',       // 是否确认提交 ?
  confirmOperation: 'Confirm the operation?',
  tips: 'Tips',                                         // 提示
  determine: 'OK',                               // 确定
  cancel: 'Cancel',                                     // 取消
  save: 'Save',
  nextStep: 'Next step',
  prevStep: 'Back',
  done: 'Done',
  close: 'Close',
  back: 'Back',
  reflash: 'Reflash',
  Hi: 'Hi',
  more: 'More',
  salaryOverview: 'Salary overview',
  total: 'Total',
  average: 'Average',
  gross: 'Gross',
  net: 'Net',
  cost: 'Cost',
  personnelOverview: 'Personnel overview',
  onJob: 'On job',
  joined: 'Joined',
  resignation: 'Resignation',
  /** 审批流程 - 付款通知审批设置 */
  payApvlSet: {
    processName: 'Process Name',                        // 流程名称
    approvalLevel: 'Approval Level',                    // 审批层级
    default: 'Default',                                 // 是否默认
    status: 'Status',                                   // 状态
    createTime: 'Create Time',                          // 创建时间
    operation: 'Operate',                               // 操作
    edit: 'Edit',                                       // 编辑
    disable: 'Disable',                                 // 禁用
    inputFilter: 'Filter',                              // 关键字筛选
    select: 'Please Select',                            // 请选择
    inputPlaceholder: 'Please Input',                   // 请输入
    newAdd: 'Add',                                  // 新增
    roleName: 'Role Name',                              // 角色名称
    roleType: 'Role Type',                              // 角色类型
    roleWarnTips: 'Please Select Role',                 // 请选择审批角色
    roleSuccessTips: 'Save Success',                    // 保存成功
    emptyTips: 'This item cannot be empty',             // 此项不能为空
    determine: 'Determine',                             // 确定
    save: 'Save',                                       // 保存
    cancel: 'Cancel',                                   // 取消
    newProcessTitle: 'Add Process',                 // 新增流程
    editProcessTitle: 'Edit Process',                   // 编辑流程
    disTitle: 'Remind',                                 // 提醒
    successTips: 'Success',                             // 成功
    cancelTips: 'Cancelled',                            // 已取消
    disText: 'Are you sure you want to disable the selected process ?',   // 确定将所选流程禁用吗?
    enaText: 'Are you sure you want to enable the selected process ?',    // 确定将所选流程启用吗?
  },

  /** 审批流程 - 付款通知审批 */
  payAdv: {
    salaryMonth: 'Salary Month',                        // 工资月份
    salaryPlaceholder: 'Please Select',                 // 请选择
    currentMonth: 'Current Month',                      // 当前月
    nearThreeMonth: 'Last Three Months',                // 近三个月
    nearOneYear: 'Nearly A Year',                       // 近一年
    other: 'Other',                                     // 其它
    startMonth: 'Start Month',                          // 开始月份
    endMonth: 'End Month',                              // 结束月份
    to: 'To',                                           // 至
    viewDetails: 'View Details',                        // 查看详情
    approvalProcess: 'Approval Process',                // 审批流程
    totalAmountPayable: 'Total Amount Payable',         // 应付总金额
    useOfFinancialBalance: 'Use Of Financial Balance',  // 使用财务余额
    totalAmountPaid: 'Total Amount Paid',               // 实付总金额
    useOfCorporateBalance: 'Use Of Corporate Balance',  // 使用对公余额
    noData: 'No Data Available',                        // 暂无数据
    proTips1: 'You have submitted your approval comments. Now the process is to',     // 您已提交审批意见, 现在流程到__
    proTips2: 'Audit Completed',                                                      // 已完成审核
    proTips3: 'You have rejected the approval opinion',                               // 您已驳回审批意见
    proTips4: 'Hang in the air',                                                      // 未完成
    proTips5: 'The salary batch you created is now transferred to',                   // 您创建的薪资批次, 现在流转到
    proTips6: 'The salary batch you created has been rejected. It is',                // 您创建的薪资批次被驳回, 是
    confirmation: 'Confirmation',                       // 确认意见
    confirm: 'Confirm',                                 // 确认
    backToCIIC: 'Back To CIIC',                         // 返回中智
    approvalComments: 'Approval Comments',              // 审批意见
    agree: 'Agree',                                     // 同意
    reject: 'Reject',                                   // 驳回
    remarksTips: 'Please fill in the remarks',          // 请填写备注
    errTips1: 'Please check the approval comments',     // 请勾选审批意见
    errTips2: 'Please fill in the rejection remarks',   // 请填写驳回备注
    errTips3: 'Remarks cannot exceed 200 characters',   // 备注不能超过200个字符
    successTips: 'Approval completed',                  // 审批完成
    submit: 'Submit',                                   // 提交
  },
  frame: {
    message: 'Message',
    unreadMessage: 'Unread message',
    enterTheMessageCenter: 'Enter the message center',
    basicInformationSettings: 'Basic information settings',
    logoutTipTitle: 'Prompt',
    logoutTipContent: 'Are you sure to exit the system?',
  },
  menu: {
    search: 'Search',
    QXInvestment: '乾象投资',
    workbench: 'Workbench',
    // 组织安排
    organization: 'Organization',
    organizationManagement: 'Organization management',
    postManagement: 'Post management',
    // 人事管理
    personnelManagement: 'Personnel',
    onboardingManagement: 'Onboarding management',
    staffManagement: 'Staff management',
    contractManagement: 'Contract management',
    // 考勤假期
    attendance: 'Attendance',
    clockInRecords: 'Clock in records',
    attendanceResultProcessing: 'Attendance result processing',
    attendanceSummary: 'Attendance summary',
    attendanceMonthlyReport: 'Attendance monthly report',
    leaveQuery: 'Leave query',
    attendanceDailyReport: 'Attendance daily report',
    attendanceSettings: 'Attendance settings',
    leaveSettings: 'Leave settings',
    // 薪酬服务
    payroll: 'Payroll',
    dataPreparation: 'Data preparation',
    salaryHistory: 'Salary history',
    salaryDistribution: 'Salary distribution',
    IITDeclaration: 'IIT declaration',
    paySlipOnly: 'Pay slip only',
    salarySetting: 'Salary Setting',
    refund: 'Refund',
    salaryCalculation: 'Salary calculation',
    salaryBackCalculation: 'Salary backcalculation',
    // 审批流程
    approvalProcess: 'Approval Settings',
    salaryApproval: 'Salary approval',
    approvalSettings: 'Approval Settings',
    billApprovalSettings: 'Bill approval settings',
    // 服务流程
    process: 'Process',
    orderCenter: 'Order center',
    billList: 'Bill list',
    invoiceList: 'Invoice list',
    meritDataManagement: 'Merit Data Management',
    meritDetail: 'Merit Data Detail',
    // 数据统计
    statistics: 'Statistics',
    staffIncomeDetails: 'Staff income details',
    staffIncomeDetailsForGroup: 'Group Staff income details',
    staffIncomeDetailsPerTaxType: 'Staff income details per tax type',
    staffIncomeSummary: 'Staff income summary',
    dataCenter: 'Data center',
    costCenterSummary: 'Cost center summary',
    salaryComparison: 'Salary comparison',
    costCenterComparison: 'Cost center comparison',
    customReport: 'Custom report',
    // 四上报表
    sishangReport: 'Sishang report',
    enterpriseInformation: 'Enterprise information',
    sishangEnterpriseReport: 'Sishang report',
    // 中智服务
    service: 'Service',
    billLists: 'Bill list',
    // 政策字典
    policy: 'Policy',
    socialSecurityPolicy: 'Social security policy',
    housingProvidentFundPolicy: 'Housing provident fund policy',
    // 平台设置
    settings: 'Settings',
    companyInformation: 'Enterprise information',
    accountSettings: 'Account settings',
    HRPermissionSettings: 'HR permission settings',
    userAuthorization: 'User authorization',
    systemSettings: 'System settings',
    codeSettings: 'Code settings',
    messageSettings: 'Message settings',
    customerAnnouncement: 'Customer announcement',
    staffPermissionManagement: 'Staff permission management',
    // 审计报表
    auditReport: '审计报表',
    payTaxCloudLogDetails: 'Pay tax cloud log details',
    payTaxCloudDailyVisitStatistics: 'Pay tax cloud daily visit statistics',
    payCloudLogDetails: 'Pay cloud log details',
    // 特斯拉股票行权
    stockExerciseEmail: 'Stock Exercise Email',
    debtManagement: 'Debt management',
    mailSettings: 'Mail settings',
    // 政策库
    policyLibrary: 'Policy library',
    policyDictionary: 'Policy dictionary',
    policyExpress: 'Policy express',
    industryReport: 'Industry report',
    serviceTemplate: 'Service template',
    documentTemplate: 'Document template',
    guidance: 'Guidance',
    // 政策库后台管理
    policyLibraryManagement: 'Policy library management',
    policyLink: 'Policy link',
    policyLibraryPermission: 'Policy library permission',
    policyExpressMailSubscription: 'Policy courier mail subscription',
    industryReportManagement: 'Industry report',
    //工资单
    payslip:'payslip',
    unpaybatchinfo:'unfinished batch info',
    payslipdetail:'Finished payslip',
    ProofMenu:'Proof',
    incomeProofMenu:'Income Proof',
    teslaCustom:'Tesla Custom',
    teslaCustomData:'Tesla Custom Record',
    teslaPayAccount:'Payroll Accounting Report',
    // 数据录入
    dataInput: '数据录入',
    overallBudget: '总体预算',
    employeeCompensation: '员工薪酬水平',
    //希捷文件配置
    seagateFile:'seagate File',
    seagateFileDownload:'seagate File Download',
    seagateFinanceReport:'seagate Finance Report'
  },
  // 工作台
  workbench: {
    shortcuts: 'Shortcuts',
    policyExpress: 'Policy Express'
  },
  // 数据中心
  reportName: 'Report name',
  numberOfEmployees: 'Number of employees',
  joinedLastMonth: 'Joined last month',
  resignationLastMonth: 'Resignation last month',
  averageAge: 'Average age',
  averageService: 'Average service',
  YoYLastMonth: 'YoY Last Month',
  dataBoard: 'Data board',
  customReport: 'Custom report',
  averageGrossSalaryForThisMonth: 'Average gross salary for',
  averageNetSalaryForThisMonth: 'Average net salary for',
  averageLaborCostForThisMonth: 'Average labor cost for',
  perCapitaLaborCost: 'Per capita labor cost',
  netSalary: 'Net salary',
  socialSecurityAndProvidentFund: 'Social security and provident fund',
  IIT: 'IIT',
  others: 'Others',
  unCounted: 'Uncounted data',
  quantile: '',
  illustration: 'Illustration',
  nativePlaceDistribution: {
    title: 'Native place distribution',
    illustration: 'The heat map of the hometown of current employees in the system.'
  },
  statisticsOfChanges:{
    title: 'Statistics of changes in employee numbers',
    illustration: 'Number of employees, Joined this month，Resignation this month.'
  },
  monthlyEmployeeSalaryStatistics: {
    title: 'Monthly employee salary statistics',
    illustration: 'Gross salary, net salary, labor cost'
  },
  salaryCompositionRatioStatistics: {
    title: 'Salary composition ratio statistics',
    illustration: 'Average labor cost ratio chart'
  },
  employeeSalaryDistributionStatistics: {
    title: 'Employee salary distribution statistics',
    illustration: 'Q–Q plot'
  },
  departmentSalaryRatioStatistics: {
    title: 'Department salary ratio statistics',
    illustration: 'Department salary ratio'
  },
  salaryTypeProportionStatistics: {
    title: 'Salary type proportion statistics',
    illustration: 'Salary type proportion.'
  },
  employeeAgeRatioStatistics: {
    title: 'Employee age ratio statistics',
    illustration: 'Employee age ratio.',
    seriesName: 'Employee age ratio'
  },
  employeeServiceRatioStatistics: {
    title: 'Employee service ratio statistics',
    illustration: 'Employee service ratio.',
    seriesName: 'Employee service ratio'
  },
  costCenterProportionStatistics: {
    title: 'Cost center proportion statistics',
    illustration: 'Cost center proportion.'
  },
  educationDistributionStatistics: {
    title: 'Education distribution statistics',
    illustration: 'Employee education ratio.',
    seriesName: 'Employee education ratio'
  },
  genderStatistics: {
    title: 'Gender statistics',
    illustration: 'Employee gender ratio.',
    seriesName: 'Employee Gender ratio'
  },
  // 订单
  createOrder: 'Create order',
  deleteOrder: 'Delete order',
  deleteSuccessfully: 'Successfully deleted',
  confirmDeleteTip: 'Do you confirm to delete order',
  wageMonth: 'Wage month',
  payDate: 'Pay date',
  remarks: 'Remarks',
  informationAttachments: 'Information attachments',
  validateWageMonth: 'The salary date cannot be earlier than the salary month',
  // 账单列表
  downloadBills: 'Download bills',
  // 发票列表
  downloadInvoice: 'Download invoice',
  // 政策库
  scopeOfApplication: 'Scope of application',
  hotSearch: 'Hot search',
  permissionTip: 'Sorry, you currently do not have permission to query data in this region.',
  permissionContact: 'Please contact the docking salesperson!',
  payPolicy: 'Pay policy',
  socialSecurityProvidentFundPolicy: 'Social Security and Provident Fund Policy',
  year: 'Year',
  minimumWage: 'Minimum wage',
  monthlySalary: 'Monthly salary',
  taxExemptAmountForSeverancePay: 'Tax exempt amount for severance pay',
  effectiveDate: 'Effective date',
  expiryDate: 'Expiry date',
  salaryType: 'Salary type',
  amount: 'Amount',
  socialSecurity: 'Social security',
  providentFund: 'Provident fund',
  upperLimitOfPensionTaxExemption: 'Upper limit of pension tax exemption',
  upperLimitOfMedicalTaxExemption: 'Upper limit of medical tax exemption',
  upperLimitOfUnemploymentTaxExemption: 'Upper limit of unemployment tax exemption',
  upperLimitOfTaxExemption: 'Upper limit of tax exemption',
  notes: 'Notes:',
  mattersTip: 'The above data is the upper limit of tax exemption for social security and provident fund, not the upper limit of payment!',
  upperLimitOfTaxExemptionTip: 'The above data is for reference only. If you have any questions about the data, please contact your customer service.',
  relatedPolicyLinks: 'Related policy links:',
  HRPolicyExpress: 'Human resources policy express',
  HRKnowledgePark: 'Human resources knowledge park',
  searchHistory: 'Search history',
  downloadReport: 'Download report',
  documentName: 'Document name',
  template: 'Template',
  businessScenario: 'Business Scenario',
  // 政策库管理
  policyType: 'Policy type',
  policyName: 'Policy name',
  policyLink: 'Policy link',
  createLink: 'Create link',
  editLink: 'Edit link',
  deleteLink: 'Delete link',
  sureDeleteLink: 'Are you sure to delete the link',
  correctLinkTip: 'Please enter the correct link',

  customerName: 'Customer Name',
  customerNumber: 'Customer Number',
  policyLibraryPermissions: 'Policy library permissions',

  accountName: 'Account name',
  userName: 'User name',
  phoneNumber: 'Phone number',
  email: 'Email',
  subscriptionStatus: 'Subscription Status',

  reportsName: 'Report name',
  uploadReport: 'Upload report',
  applicableIndustry: 'Applicable industry',
  reportCover: 'Report Cover',
  reportFile: 'Report File',
  handleCreateReport: 'Create report',
  handleEditReport: 'Edit report',
  handleDeleteReport: 'Delete report',
  sureDeleteReport: 'Are you sure to delete the report',

  // 表格、表单、按钮等
  clear: 'Clear',
  inputKeyword: 'Please enter keywords',
  keywords: 'Keyword',
  pleaseSelect: 'Please select',
  pleaseQuery: 'Please query',
  pleaseUpload: 'Please upload',
  inputPlaceholder: 'Please enter',
  selectYearMonth: 'Select year and month',
  selectDate: 'Select date',
  rangeSeparator: 'to',
  from: 'From',
  to: 'To',
  startDate: 'Start date',
  endDate: 'End date',
  selectStaff: 'Select staff',
  selectCards: 'Select idCard',
  selectCostCenter: 'Select cost center',
  selectTaxType: 'Select tax type',
  displayItemConfiguration: 'Display item configuration',
  displayItems: 'Display Items',
  hiddenItems: 'Hidden Items',
  salaryMonth: 'Salary month',
  export: 'Export',
  displayItem: 'Display item (Drag items for sorting)',
  allItem: 'All item （Drag or click items to the upper area）',
  seq: 'No.',
  selectAll: 'Select all',
  noData: 'No data',
  noReport: 'There are currently no custom reports available. Go and create them now.',
  editReport: 'Edit report',
  viewStatistics: 'View statistics',
  createCustomReport: 'Create custom report',
  editCustomReport: 'Edit custom report',
  enterReportName: 'Please enter a report name',
  reportType: 'Report type',
  searchStatisticalCaliber: 'Please search for statistical caliber',
  selectStatisticalCaliber: 'Please select statistical caliber',
  caliberSelected: 'caliber selected',
  algorithm: 'Algorithm for months of entry and exit',
  salaryRange: 'Salary range',
  comparisonRange: 'Comparison range',
  startYearMonth: 'Start year month',
  endYearMonth: 'End year month',
  viewDetails: 'View details',
  handleCreate: 'Create',
  handleEdit: 'Edit',
  handleDelete: 'Delete',
  startDownloading: 'Start downloading',
  sum: 'Sum',
  operation: 'Operation',
  uploadFiles: 'Upload files',
  uploadFilesTip: 'Drag the file here or click Upload.',
  turnOff: 'Automatically turn off after',
  seconds: 'seconds',
  // 日历
  datePicker: {
    workday: 'Workday',
    dayOff: 'Day off',
    statutoryHoliday: 'Statutory holiday'
  },
  selectSummaryStaff: 'Please select summary items',
  download: 'Download',
  zipdownload: 'Batch download',
  zipdownloadTask: 'Batch download task',
  batchNo: 'Batch No',
  createTime: 'Create time',
  salesman: "Salesman",
  payAmountTotal: 'Total payable amount',
  actAmountTotal: 'Total paid amount',
  successTips: 'Save Success',
  noEmptyColumn: 'No Empty Column',
  pleaseSelectPaidResultRow: 'Please Select Paid Result Row.',
  status: 'Status',
  enabledownload: 'download',
  preparing: 'preparing',
  previewWechatPayslip : 'Preview Wechat Payslip',
  previewEMailPayslip : 'Preview EMail Payslip',
  sumRemark:"Display item (Drag items for sorting) (Only numeric items can be summarized)",
  incomeProof: 'Download Income Proof',
  incomeProof1: 'Income Proof',
  createProofAndDownload:"Merge build proof and download",
  createEachAndDownload:"Each employee generates a certificate and downloads it",
  downloadWordType:"Download WORD Version",
  downloadPdfType:"Download PDF Version",
  cusHeadRemark:"For the sake of the aesthetics of salary proof documents, it is recommended to display no more than 10 items",
  dealStatus:"Processing status",
  perStatusType:"Personnel data type",
  companyCode:"company",
  query:'query',
  confirm:'confirm',
  batchIds:"Please enter batch",
  queryDate:"Query Date",
  queryCompany:"Please select the company",
  sendEmail:"Send Email"
}
